export default __webpack_public_path__ + "static/media/AppraisalPP1.73aec39a.jpg";